import CONFIGURACIONES from "../../../../util/constants";
import WaveButton from "../../../global/WaveButton";

import { useForm } from "react-hook-form";
import React, {useEffect, useState} from "react";
import OWASP from "../../../../util/owasp";

import {el, es} from "date-fns/locale";
import { parse, format, set } from "date-fns";
import DatePicker, {registerLocale} from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {Http} from "../../../../helpers/Http";
import {Functions} from "../../../../helpers/Functions";
import AddressModal from "../../../global/modals/AddressModal";

registerLocale("es-sunday", {
    ...es,
    options: {
        ...es.options,
        weekStartsOn: 0, // 0 = Domingo, 1 = Lunes
    },
});
const MantEvaluation = ({ MySwal, title, idEdit, fnCrear, showCreate, list, icon, user, destinosCredito, formasPago, monedas, zona, agencia, metodosPago}) => {
    const {handleSubmit, resetField, reset, register, setValue, formState: {errors}} = useForm({mode: "onChange"});
    const [clienteId, setClienteId] = useState(CONFIGURACIONES.INIT.NUMBER);
    const [tabActive, setTabActive] = useState(CONFIGURACIONES.INIT.NUMBER);
    const [iconActive, setIconActive] = useState(CONFIGURACIONES.INIT.STRING);
    const [isBloqueado, setIsBloqueado] = useState(CONFIGURACIONES.INIT.STATUS_TRUE);
    const [searchTerm, setSearchTerm] = useState(CONFIGURACIONES.INIT.STRING);
    const [referenciaText, setReferenciaText] = useState(CONFIGURACIONES.INIT.STRING);
    const [validacionInput, setValidacionInput] = useState(CONFIGURACIONES.INIT.STRING);

    const onSubmit1 = (form) => {
        form['zonaId'] = zona;
        form['agenciaId'] = agencia;
        fnCrear(form);
    };

    useEffect(() => {
        setIsBloqueado(CONFIGURACIONES.INIT.STATUS_TRUE);
        setClienteId(CONFIGURACIONES.INIT.NUMBER);
        setValue('clienteId', '')
        reset();
    }, [zona, agencia, list]);


    const handleCheck = (id) => {
        setIsBloqueado(CONFIGURACIONES.INIT.STATUS_FALSE);
        setClienteId(id);
        setValue('clienteId', id);
        setValue("asesor", `${user.colaborador.nombres} ${user.colaborador.apellidoPaterno} ${user.colaborador.apellidoMaterno}`)
    };


    const filteredData = list.filter((item) =>
        item.numeroDocumento.toLowerCase().includes(searchTerm.toLowerCase()) || item.razonSocial.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <>
            { idEdit >= CONFIGURACIONES.INIT.NUMBER && <>
            {/* <h5 className="card-title font-weight-bold">Editando Empleado</h5> */}
                <div className="card-content">
                    <form action="" className="form" onSubmit={handleSubmit(onSubmit1)} autoComplete="off">
                        <div className="row">
                            <div className="col-xs-12 col-md-12">
                                <h5 className="card-title font-weight-bold"><i className={`mdi ${icon}`}></i> {title}</h5>

                                <div className="row mt-3">
                                    <div className="col-xs-12 col-md-12">
                                        {/* Input alineado con la tabla */}
                                        <div className="d-flex align-items-center mb-3 col-md-6 pl-0">
                                            <input
                                                type="text"
                                                name="buscar"
                                                id="buscar"
                                                className="form-control form-control-sm w-50 me-2"
                                                placeholder="Buscar..."
                                                onChange={(e) => {
                                                    setSearchTerm(e.target.value);
                                                }}
                                            />
                                        </div>

                                        {/* Tabla */}
                                        <div className="table-responsive">
                                            <table className="table table-bordered compact-table align-middle text-nowrap">
                                                <thead className="bg-success text-white">
                                                <tr>
                                                    <th className="text-center">Seleccionar</th>
                                                    <th>T. Documento</th>
                                                    <th>Num. Documento</th>
                                                    <th>Nombres/Razón Social</th>
                                                    <th>Actividad</th>
                                                    <th>Asesor</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {filteredData.length > 0? (
                                                    filteredData.map((el, index) => (
                                                    <React.Fragment key={index}>
                                                        <tr>
                                                            <td className="text-center">
                                                                <input type="radio" className="text-center" checked={el.id === clienteId } onChange={() => handleCheck(el.id)}/>
                                                            </td>
                                                            <td>{el.tipoDocumentoNombre}</td>
                                                            <td>{el.numeroDocumento}</td>
                                                            <td>{el.razonSocial}</td>
                                                            <td>{el.actividadNegocioNombre}</td>
                                                            <td>{el.asesor}</td>
                                                        </tr>
                                                    </React.Fragment>))

                                                ): (<tr><td className="align-middle p-2 bg-white text-danger font-bold" colSpan={6}>{CONFIGURACIONES.MESSAGES.LIST_EMPTY}</td></tr>)}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <hr className="bg-success pt-1" />


                                <div className="row d-flex justify-content-center mt-5">
                                    <div className="col-xs-12 col-md-3">
                                        <div className="form-group">
                                            <label htmlFor="destinoCreditoId" className="control-label col-form-label">Destino del Crédito <span className="text-danger">*</span></label>
                                            <select
                                                {...register("destinoCreditoId", {
                                                    required: OWASP.REQUIRED,
                                                    disabled: isBloqueado,
                                                    onChange: (e) => {

                                                    }
                                                })} className="form-control" id="destinoCreditoId"  defaultValue={""}
                                            >
                                                <option value="" disabled={CONFIGURACIONES.INIT.STATUS_TRUE}>Seleccione</option>
                                                {
                                                    destinosCredito.map((el, index) => (
                                                        <option key={index} value={el.id}>{el.nombre}</option>
                                                    ))
                                                }
                                            </select>
                                            <small className="invalid-feedback"> { errors.destinoCreditoId && errors.destinoCreditoId.message }</small>
                                        </div>
                                    </div>

                                    <div className="col-xs-12 col-md-3">
                                        <div className="form-group">
                                            <label htmlFor="montoSolicitado" className="control-label col-form-label">Monto Solicitado <span className="text-danger">*</span></label>
                                            <input
                                                {...register("montoSolicitado", {
                                                    required: OWASP.REQUIRED,
                                                    disabled: isBloqueado,
                                                    pattern: {
                                                        value: OWASP.VALIDATIONS.ONLY_DECIMALS_NOT_ZERO_NEGATIVE,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    }
                                                })}
                                                type="text" className="form-control" id="montoSolicitado" placeholder="" maxLength={10} />
                                            <small className="invalid-feedback"> { errors.montoSolicitado && errors.montoSolicitado.message }</small>
                                        </div>
                                    </div>

                                    <div className="col-xs-12 col-md-2">
                                        <div className="form-group">
                                            <label htmlFor="monedaId" className="control-label col-form-label">Moneda <span className="text-danger">*</span></label>
                                            <select
                                                {...register("monedaId", {
                                                    required: OWASP.REQUIRED,
                                                    pattern: {
                                                        value: OWASP.VALIDATIONS.ONLY_NUMBERS_INTEGER,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    },
                                                    disabled: isBloqueado,
                                                    onChange: (e) => {

                                                    }
                                                })} className="form-control" id="monedaId"
                                            >
                                                {
                                                    monedas.map((el, index) => (
                                                        <option key={index} value={el.id}>{el.nombre}</option>
                                                    ))
                                                }
                                            </select>
                                            <small className="invalid-feedback"> { errors.monedaId && errors.monedaId.message }</small>
                                        </div>
                                    </div>

                                    <div className="col-xs-12 col-md-3">
                                        <div className="form-group">
                                            <label htmlFor="formaPago" className="control-label col-form-label">Forma de Pago <span className="text-danger">*</span></label>
                                            <select
                                                {...register("formaPago", {
                                                    required: OWASP.REQUIRED,
                                                    disabled: isBloqueado,
                                                    onChange: (e) => {
                                                        let value = e.target.value
                                                        let arrData = value.split('@@');
                                                        setValue("frecuencia", arrData[1]);
                                                        setValue("formaPagoId", arrData[0]);
                                                    }
                                                })} className="form-control" id="formaPago"  defaultValue={""}
                                            >
                                                <option value="" disabled={CONFIGURACIONES.INIT.STATUS_TRUE}>Seleccione</option>
                                                {
                                                    formasPago.map((el, index) => (
                                                        <option key={index} value={`${el.id}@@${el.frecuencia_dias}`}>{el.nombre}</option>
                                                    ))
                                                }
                                            </select>
                                            <input type="hidden" name="formaPagoId"
                                                   {...register('formaPagoId', {
                                                       required: OWASP.REQUIRED,
                                                       pattern: {
                                                           value: OWASP.VALIDATIONS.ONLY_NUMBERS_INTEGER,
                                                           message: OWASP.MESSAGES.DEFAULT
                                                       }
                                                   })} />
                                            <small className="invalid-feedback"> { errors.formaPagoId && errors.formaPagoId.message }</small>
                                        </div>
                                    </div>
                                </div>

                                <div className="row mt-2 d-flex justify-content-center">
                                    <div className="col-xs-12 col-md-3">
                                        <div className="form-group">
                                            <label htmlFor="plazo" className="control-label col-form-label">Plazo <span className="text-danger">*</span></label>
                                            <input
                                                {...register("plazo", {
                                                    required: OWASP.REQUIRED,
                                                    disabled: isBloqueado,
                                                    pattern: {
                                                        value: OWASP.VALIDATIONS.ONLY_NUMBERS_INTEGER,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    }
                                                })}
                                                type="text" className="form-control" id="plazo" placeholder="" />
                                            <small className="invalid-feedback"> { errors.plazo && errors.plazo.message }</small>
                                        </div>
                                    </div>

                                    <div className="col-xs-12 col-md-3">
                                        <div className="form-group">
                                            <label htmlFor="frecuencia" className="control-label col-form-label">Frecuencia <span className="text-danger">*</span></label>
                                            <input
                                                {...register("frecuencia", {
                                                    required: OWASP.REQUIRED,
                                                    disabled: isBloqueado,
                                                    pattern: {
                                                        value: OWASP.VALIDATIONS.ONLY_NUMBERS_INTEGER,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    }
                                                })}
                                                type="text" className="form-control" id="frecuencia" placeholder="" readOnly={CONFIGURACIONES.INIT.STATUS_TRUE} />
                                            <small className="invalid-feedback"> { errors.frecuencia && errors.frecuencia.message }</small>
                                        </div>
                                    </div>

                                    <div className="col-xs-12 col-md-5">
                                        <div className="form-group">
                                            <label htmlFor="asesor" className="control-label col-form-label">Asesor <span className="text-danger">*</span></label>
                                            <input
                                                {...register("asesor", {
                                                    required: OWASP.REQUIRED,
                                                })}
                                                type="text" className="form-control" id="asesor" placeholder="" readOnly={CONFIGURACIONES.INIT.STATUS_TRUE} />
                                            <small className="invalid-feedback"> { errors.asesor && errors.asesor.message }</small>
                                        </div>
                                    </div>
                                </div>

                                <div className="row mt-2 d-flex justify-content-center">
                                    <div className="col-xs-12 col-md-11">
                                        <div className="form-group">
                                            <label htmlFor="comentarioContacto" className="control-label col-form-label">Comentario</label>
                                            <textarea
                                                {...register("comentarioContacto", {
                                                    disabled: isBloqueado,
                                                })}
                                                className="form-control no-resize" rows="4" id="comentarioContacto" placeholder=""></textarea>
                                            <small className="invalid-feedback"> { errors.comentarioContacto && errors.comentarioContacto.message }</small>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="row d-flex justify-content-center mt-2">
                                    <div className="col-xs-11 col-md-11">
                                        <h3 className="h5 text-muted">Para Desembolso</h3>
                                    </div>
                                    
                                    <div className="col-xs-12 col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="metodoDesembolso" className="control-label col-form-label">Método de Desembolso <span className="text-danger">*</span></label>
                                            <select
                                                {...register("metodoDesembolso", {
                                                    required: OWASP.REQUIRED,
                                                    disabled: isBloqueado,
                                                    onChange: (e) => {
                                                        let selectedOption = e.target.options[e.target.selectedIndex];
                                                        let arrData = selectedOption.value.split('@@');
                    
                                                        setValue('metodoDesembolsoId', arrData[0]);
                                                        setReferenciaText(arrData[2]);
                                                        setValidacionInput(new RegExp(arrData[1]));
                                                        resetField("referencia");
                                                    }
                                                })} className="form-control" id="metodoDesembolso" defaultValue={""}
                                            >
                                                <option value="" disabled>Seleccione</option>
                                                {
                                                    metodosPago.map((el, index) => (
                                                        <option key={index} value={`${el.id}@@${el.validacion_input}@@${el.valor_label}`}>{el.nombre}</option>
                                                    ))
                                                }
                                            </select>
                                            <small className="invalid-feedback"> { errors.metodoDesembolso && errors.metodoDesembolso.message }</small>

                                            <input type="hidden" name="metodoDesembolsoId" id="metodoDesembolsoId" 
                                                {...register("metodoDesembolsoId", { 
                                                    required: OWASP.REQUIRED,
                                                    pattern: {
                                                        value: OWASP.VALIDATIONS.ONLY_NUMBERS_INTEGER,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    },
                                                })} />
                                        </div>
                                    </div>

                                    <div className="col-xs-12 col-md-7">
                                        {referenciaText !== CONFIGURACIONES.INIT.STRING &&  <div className="form-group">
                                            <label htmlFor="referencia" className="control-label col-form-label">{referenciaText} <span className="text-danger">*</span></label>
                                            <input
                                                {...register("referencia", {
                                                    required: OWASP.REQUIRED,
                                                    pattern: {
                                                        value: validacionInput,
                                                        message: OWASP.MESSAGES.DEFAULT
                                                    },
                                                    disabled: isBloqueado,
                                                })}
                                                type="text" className="form-control" id="referencia" placeholder="" maxLength={CONFIGURACIONES.INIT.MAX_REFERENCIA_TIPO_DESEMBOLSO} />
                                            <small className="invalid-feedback"> { errors.referencia && errors.referencia.message }</small>
                                        </div>}
                                    </div>
                                </div>
                            </div>
                            <input type="hidden" name="clienteId"
                               {...register('clienteId', {
                                    required: OWASP.REQUIRED,
                                    pattern: {
                                        value: OWASP.VALIDATIONS.ONLY_NUMBERS_INTEGER,
                                        message: OWASP.MESSAGES.DEFAULT
                                    }
                                })} />
                        </div>

                        <div className="action-form mt-3 d-flex justify-content-end">
                            <div className="form-group m-0 p-0 text-left">
                                {showCreate && clienteId > 0 && <WaveButton type="submit" className="btn btn-sm btn-success waves-effect">
                                    <i className="mdi mdi-content-save-settings"></i> Guardar
                                </WaveButton>}
                            </div>
                        </div>
                    </form>
               </div>
            </>
            }
        </>
    )
}
export default MantEvaluation;